import IframeModal from './iframe-modal.vue'
export default IframeModal
